import PackageModel from '@geartrack/shared-lib/dist/PackageModel'
import { IPackagesRepository } from './packages'
import { usePackageStoreNew } from '../state/packages.store.new'

export class PackagesRepositoryZustand implements IPackagesRepository {
  addPackage(pkg: PackageModel) {
    return this.upsertPackage(pkg)
  }

  updatePackage(pkg: PackageModel, changes: Partial<PackageModel>) {
    return this.upsertPackage(pkg.edit(changes))
  }

  removePackage(pkg: PackageModel) {
    usePackageStoreNew.setState(state => {
      delete state.packages[pkg.computedKey]
    })
  }

  addSortFieldLastStateDate(pkg: PackageModel, dateInMs: number) {
    const updated = pkg.updateOrder(dateInMs)

    if (updated !== pkg) {
      // new reference means the value was updated
      // we need to save it
      return this.upsertPackage(updated)
    }
  }

  toggleCollapsePackage(pkg: PackageModel) {
    return this.upsertPackage(pkg.edit({ collapsed: !pkg.collapsed }))
  }

  /*
  |--------------------------------------------------------------------------
  | Internal
  |--------------------------------------------------------------------------
  */
  private upsertPackage(pkg: PackageModel) {
    usePackageStoreNew.setState(state => {
      state.packages[pkg.computedKey] = pkg
    })
  }
}

export const localRepoInstance = new PackagesRepositoryZustand()
